<div class="container">
    <div class="alert alert-secondary" role="alert">
        {{text | localize}}
    </div>
</div>
